import { RequirementReviewPolicy } from "@wingspanhq/wingspan-api-sdk";

export const selectorIsReviewStrategyApproval = (
  reviewPolicy: RequirementReviewPolicy | undefined
) => {
  return (
    reviewPolicy === RequirementReviewPolicy.ALWAYS_REQUIRED ||
    reviewPolicy === RequirementReviewPolicy.ON_FAIL
  );
};
